import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {activateLayer, displayRestoreLayerPopup, updateMapProperties} from '../../actions';
import {connect} from 'react-redux';
import Cookies from 'universal-cookie';
import {isJSON} from '../../config/dynamicUrlHelper';
import {Base64} from 'js-base64';
import {trans} from '../../config/translation';

/**
 * React Component that handles modal popup for Restore layer.
 * This Component is using Bootstrap Modal as base
 */
class RestoreLayerPopup extends React.Component {
    constructor(props) {
        super(props);
        this.onHide = this.onHide.bind(this);
    }

    /**
     * restore layer from cookies
     */
    restoreLayerFromCookies() {
        const cookies = new Cookies();
        if (cookies.get('prims_dynamic_url')) {
            const dynamicUrlJsonString = Base64.decode(cookies.get('prims_dynamic_url'));
            this.processDynamicUrl(dynamicUrlJsonString);
            this.props.displayRestoreLayerPopup({status: false});
        }
    }

    /**
     * process dynamic layer
     *
     * @param dynamicUrlJsonString
     */
    processDynamicUrl(dynamicUrlJsonString) {
        if (isJSON(dynamicUrlJsonString)) {
            const dynamicUrlObj = JSON.parse(dynamicUrlJsonString);
            dynamicUrlObj.layers.reverse();
            dynamicUrlObj.layers.forEach((prevLayer) => {
                this.props.layers.forEach(layerGroup => {
                    const newLayer = layerGroup.layers.find(layer => {
                        if (layer.id === prevLayer.id) {
                            layer.opacity = prevLayer.opacity;
                            layer.hide = prevLayer.hide;
                            layer.layer_active.layer_time = prevLayer.layer_time;
                            prevLayer.subLayers.forEach((prevSubLayer, index) => {
                                if (prevSubLayer.id === layer.layer_active.layer_lists[index].id) {
                                    layer.layer_active.layer_lists[index].is_active = prevSubLayer.is_active;
                                }
                            });
                            return layer;
                        }
                    });
                    if (newLayer) {
                        this.props.activateLayer(newLayer);
                    }
                });
            });
            this.props.updateMapProperties(dynamicUrlObj.mapProperties);
            window.queryUrlLoaded = 1;
        } else {
            this.displayDefaultLayer();
        }
    }

    /**
     * display default layer
     */
    displayDefaultLayer() {
        window.queryUrlLoaded = 1;
        this.props.layers.map(layerGroup => {
            layerGroup.layers.map(layer => {
                if (layer.is_default) {
                    this.props.activateLayer(layer);
                }
            });
        });
    }

    /**
     * hide modal event handler
     */
    onHide() {
        this.displayDefaultLayer();
        this.props.displayRestoreLayerPopup({status: false});
    }

    render() {
        return (
            <Modal id="restore-layer-popup"
                   show={this.props.restoreLayerPopupData.status}
                   onHide={this.onHide}
                   backdrop="static"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Body>
                    <h3>
                        {trans('session.title')}
                    </h3>
                    <p>
                        {trans('session.description')}
                    </p>
                    <div className="btn-groups">
                        <button className="btn btn-light"
                                onClick={() => {
                                    this.displayDefaultLayer();
                                    this.props.displayRestoreLayerPopup({status: false})
                                }}>
                            {trans('session.new-session')}
                        </button>
                        <button className="btn btn-primary"
                                onClick={() => this.restoreLayerFromCookies()}>
                            {trans('session.continue-session')}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapActionToProps = {
    displayRestoreLayerPopup,
    updateMapProperties,
    activateLayer
};

const mapStateToProps = state => {
    return {
        restoreLayerPopupData: state.restoreLayerPopupData,
        layers               : state.layers,
    };
};

export default connect(mapStateToProps, mapActionToProps)(RestoreLayerPopup);